import React, { useState } from "react";
import * as Yup from "yup";

import { updateTrack } from "../../services/Contigo/patient";

import Spinner from "../../atoms/Spinner";
import { ModalStepper } from "../ModalStepper"
import { ModalStep } from "../../atoms/ModalStep";
import { ResponseResult } from "../../atoms/ResponseResult";
import { ChangeContigoResponsibleForm } from "../../atoms/ChangeContigoResponsibleForm";
import { ChangeContigoResponsibleWarning } from "../../atoms/ChangeContigoResponsibleWarning";

import greenIndicator from '../../assets/imgs/update.png';

export const ChangeContigoResponsibleStepper = ({ onClose, trackId, setCurrentResponsible }) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");

  const updateTrackResponsible = async (newResponsible) => {
    setLoading(true);
    try {
      const [name, id_responsible] = newResponsible.split(":");
      const response = await updateTrack(trackId, {
        id_responsible
      });
      if (!response.data.length) setResult("error");
      else {
        setResult("success");
        setCurrentResponsible(name);
      }
    } catch (error) {
      console.error(error);
      setResult("error");
    } finally {
      setLoading(false);
    }
  };

  const resultMessages = {
    error: {
      title: "Inténtalo de nuevo",
      subtitle: "el cambio de responsable no pudo completarse",
    },
    success: {
      title: "Responsable actualizado",
      img: greenIndicator,
      imgStyles: {
        maxWidth: "48px",
        padding: "0 0 8px",
      }
    }
  };

  const validateSchema = Yup.object({
    responsible: Yup.string().required("Campo obligatorio"),
  });

  if (loading) return (
    <div
      style={{
        display: "flex",
        height: "100%",
        alignItems: "center"
      }}
    >
      <Spinner />
    </div>
  );

  if (result) return <ResponseResult type={result} {...resultMessages[result]} />;

  return (
    <ModalStepper
      initialValues={{ responsible: "" }}
      onSubmit={async ({ values: { responsible } }) => {
        await updateTrackResponsible(responsible);
      }}
      onClose={onClose}
      showCancelButton
    >
      <ModalStep>
        <ChangeContigoResponsibleWarning />
      </ModalStep>
      <ModalStep textButtonNext="Si" validationSchema={validateSchema}>
        <ChangeContigoResponsibleForm />
      </ModalStep>
    </ModalStepper>
  )
};
